import React, { useEffect, useState } from 'react';

const API_BASE = "https://backend.alephmedia.ro/api";

function InvitationsAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(1);
  const [expiresAt, setExpiresAt] = useState('');
  const [accountValidityDays, setAccountValidityDays] = useState('');
  const [note, setNote] = useState('');
  const [campaignName, setCampaignName] = useState('');
  const [authUser, setAuthUser] = useState('');
  const [authPass, setAuthPass] = useState('');
  const [authHeader, setAuthHeader] = useState(localStorage.getItem('invAdminAuth') || '');

  function handleLogin(e) {
    e.preventDefault();
    const hdr = 'Basic ' + btoa(`${authUser}:${authPass}`);
    localStorage.setItem('invAdminAuth', hdr);
    setAuthHeader(hdr);
    setAuthUser('');
    setAuthPass('');
  }

  function handleLogout() {
    localStorage.removeItem('invAdminAuth');
    setAuthHeader('');
    setItems([]);
  }

  async function load() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/admin/invitations`, {
        headers: { 'Authorization': authHeader }
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        setError('Neautorizat. Verifică user/parolă.');
        localStorage.removeItem('invAdminAuth');
        setAuthHeader('');
        return;
      }
      if (res.ok) {
        setItems(Array.isArray(data.data) ? data.data : (Array.isArray(data) ? data : []));
      } else {
        throw new Error(data.message || 'Eroare la încărcarea invitațiilor');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (authHeader) load();
  }, [authHeader]);

  async function createInvitation(e) {
    e.preventDefault();
    setError(null);
    try {
      const body = { count: Number(count) };
      if (expiresAt) body.expires_at = expiresAt;
      if (accountValidityDays) body.account_validity_days = Number(accountValidityDays);
      if (note) body.note = note;
      if (campaignName) body.campaign_name = campaignName;
      const res = await fetch(`${API_BASE}/admin/invitations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': authHeader },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        setError('Neautorizat. Verifică user/parolă.');
        localStorage.removeItem('invAdminAuth');
        setAuthHeader('');
        return;
      }
      if (!res.ok) throw new Error(data.message || 'Eroare la creare invitație');
      setCount(1);
      setExpiresAt('');
      setAccountValidityDays('');
      setNote('');
      setCampaignName('');
      await load();
    } catch (e) {
      setError(e.message);
    }
  }

  async function deleteInvitation(id) {
    if (!window.confirm('Sigur ștergi invitația?')) return;
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/admin/invitations/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': authHeader }
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) {
        setError('Neautorizat. Verifică user/parolă.');
        localStorage.removeItem('invAdminAuth');
        setAuthHeader('');
        return;
      }
      if (!res.ok) throw new Error(data.message || 'Eroare la ștergere');
      await load();
    } catch (e) {
      setError(e.message);
    }
  }

  if (!authHeader) {
    return (
      <div className="auth-wrapper">
        <div className="auth-container" style={{ width: 420 }}>
          <div className="auth-logo">
            <a href="/"><img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" /></a>
          </div>
          <h1 className="auth-title">Autentificare Admin Invitații</h1>
          <form onSubmit={handleLogin}>
            <input className="form-field" type="text" placeholder="Utilizator" value={authUser} onChange={e => setAuthUser(e.target.value)} required />
            <input className="form-field" type="password" placeholder="Parolă" value={authPass} onChange={e => setAuthPass(e.target.value)} required />
            <button className="form-submit" type="submit">Autentifică</button>
            {error && <p className="error" style={{ marginTop: 12 }}>{error}</p>}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-container" style={{ width: 900, maxWidth: '95%' }}>
        <div className="auth-logo">
          <a href="/"><img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" /></a>
        </div>
        <h1 className="auth-title">Administrare invitații</h1>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
          <button className="form-submit" style={{ width: 'auto', padding: '10px 16px' }} onClick={handleLogout}>Logout</button>
        </div>

        <div className="form-section">
          <h2>Creează invitații</h2>
          <p style={{ marginBottom: '16px', color: '#666', fontSize: '14px' }}>
            Fiecare invitație generată poate fi folosită o singură dată, prevenind partajarea linkurilor.
          </p>
          <form onSubmit={createInvitation} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px' }}>
            <div>
              <label>Număr de invitații</label>
              <input className="form-field" type="number" value={count} onChange={e => setCount(e.target.value)} min={1} max={1000} required />
            </div>
            <div>
              <label>Nume campanie (opțional)</label>
              <input className="form-field" type="text" value={campaignName} onChange={e => setCampaignName(e.target.value)} placeholder="Ex: Campanie Q1 2025" />
            </div>
            <div>
              <label>Expiră la (opțional)</label>
              <input className="form-field" type="datetime-local" value={expiresAt} onChange={e => setExpiresAt(e.target.value)} />
            </div>
            <div>
              <label>Valabilitate cont (zile, opțional)</label>
              <input className="form-field" type="number" value={accountValidityDays} onChange={e => setAccountValidityDays(e.target.value)} min={1} placeholder="Ex: 30" />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label>Detalii (text, opțional)</label>
              <textarea className="form-field" value={note} onChange={e => setNote(e.target.value)} placeholder='campanie marketing 2025' rows={3} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <button className="form-submit" type="submit" style={{ width: 'auto', padding: '10px 16px' }}>Creează {count === 1 ? 'invitație' : `${count} invitații`}</button>
            </div>
          </form>
          {loading && <p className="loading">Se încarcă...</p>}
          {error && <p className="error">{error}</p>}
        </div>

        <div className="account-section">
          <h3>Invitații existente</h3>
          <div className="payments-table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Token</th>
                  <th>Uses</th>
                  <th>Max</th>
                  <th>Campanie</th>
                  <th>Expires</th>
                  <th>Valabilitate cont</th>
                  <th>Detalii</th>
                  <th>Link</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id}>
                    <td>{it.id}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: '11px' }}>{it.token}</td>
                    <td>{it.uses}</td>
                    <td>{it.max_uses}</td>
                    <td>{it.campaign_name || '-'}</td>
                    <td>{it.expires_at || '-'}</td>
                    <td>{it.account_validity_days ? `${it.account_validity_days} zile` : '-'}</td>
                    <td><pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{it.note || '-'}</pre></td>
                    <td>
                      {it.link ? (
                        <a href={it.link} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', wordBreak: 'break-all' }}>
                          {it.link}
                        </a>
                      ) : '-'}
                    </td>
                    <td>
                      <button className="form-submit delete" style={{ width: 'auto', padding: '6px 10px' }} onClick={() => deleteInvitation(it.id)}>Șterge</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvitationsAdmin;
